import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { HttpService } from './http.service';
import { UserService } from './user.service';
import { DomainService } from './domain.service';
import 'rxjs/add/observable/interval';

@Injectable()
export class AuthService {
    private url: string = environment.base_url;
    private tokenRefresher = undefined;

    constructor(
        private httpService: HttpService,
        private userService: UserService,
        private domainService: DomainService
    ) {
    }

    init() {
        if (this.userService.getToken()) {
            this.updateToken();
            this.subscribeToKeepAliveToken();
        }
    }

    private subscribeToKeepAliveToken() {
        this.tokenRefresher = Observable.interval(10000).subscribe(() => {
            const tokenDoNotUpdateBefore = this.userService.getTokenNBFTime();
            if (
                !tokenDoNotUpdateBefore ||
                (tokenDoNotUpdateBefore && tokenDoNotUpdateBefore <= Math.floor(Date.now() / 1000))
            ) {
                this.updateToken();
            }
        });
    }

    private unSubscribeToKeepAliveToken() {
        try {
            this.tokenRefresher.unsubscribe();
        } catch (e) { }
    }

    private updateToken() {
        this.keepAlive().subscribe(response => {
            if (response.data && response.meta.token) {
                this.userService.save(response.meta.token, JSON.stringify(response.data));
            }
        });
    }

    setUser(token: string, data: string) {
        this.subscribeToKeepAliveToken();
        this.userService.save(token, data);
    }

    login(payload: Object) {
        return this.httpService.post(this.url + '/login', payload).map(resp => resp);
    }

    keepAlive() {
        return this.httpService.post(this.url + '/keep_alive').map(resp => resp);
    }

    logout(): void {
        this.unSubscribeToKeepAliveToken();
        this.domainService.deleteDomainVerified();
        this.userService.delete();
    }

    lock(): void {
        this.unSubscribeToKeepAliveToken();
        this.userService.lock();
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/auth.service.ts